import React from "react";
import jsPDF from "jspdf";

const FileViewer = ({ url, fileType }) => {
  const handleDownloadPDF = () => {
    if (fileType === "pdf") {
      const doc = new jsPDF();
      doc.text("Loading PDF from URL...", 10, 10); // Placeholder text
      doc.save("downloaded-file.pdf");
    }
  };

  return (
    <div className="text-center" onContextMenu={(e) => e.preventDefault()}>
      {fileType === "pdf" ? (
        <div className="mypdf">
          <embed
            src={url}
            type="application/pdf"
            width="100%"
            height="600px"
            onError={() => (
              <div className="error">
                <span>Failed to load document</span>
              </div>
            )}
          />
          <button onClick={handleDownloadPDF} className="btn btn-primary mt-3">
            Download PDF
          </button>
        </div>
      ) : (
        <div>
          <img src={url} alt="Failed to load document" className="imgfile" />
        </div>
      )}
    </div>
  );
};

export default FileViewer;
